import { environment } from './environments/environment';
import { enableProdMode } from '@angular/core';

import packageInfo from '../package.json';
import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';

if (environment.production) {
    enableProdMode();
    console.log = () => {};
}
console.log('%c⧭ Version ', 'color: #00861b; font-size: 16px; font-weight: 600', packageInfo.version);
// Sentry.init({
//   dsn: 'https://9accadbb073bb83d2b139414e0fa44fc@o4508177132552192.ingest.de.sentry.io/4508177172398160',
//   integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
//   tracesSampleRate: 1.0,
//   tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0,
// });

bootstrapApplication(AppComponent, appConfig)
    .then(() => {
        const loader = document.getElementById('global-loader');
        if (loader) {
            loader.style.opacity = '0';
            loader.style.visibility = 'hidden';
            setTimeout(() => loader.remove(), 300); // optional cleanup
        }
    })
    .catch((err) => console.error(err));
